import React from "react"
import { Link, Navigate } from "react-router-dom"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { useTranslation } from "react-i18next"

import AuthBrandingLogo from "components/Authentication/AuthBrandingLogo"
import useAuthPageBranding from "hooks/useAuthPageBranding"
import { ROUTES } from "constants/routes"
import { isAuthenticated } from "utils/authUtils"
import {
  getFirstAccessibleRoute,
  getAuthContextFromStorage,
} from "utils/accessibleRoutes"
import { usePortalTenant } from "context/PortalTenantContext"

const ForbiddenAccess = () => {
  const { t } = useTranslation()
  const { brandTitle, authPageClassName } = useAuthPageBranding(
    t("Access Forbidden")
  )
  const { isCustomLoginActive } = usePortalTenant()

  if (isAuthenticated()) {
    const target = getFirstAccessibleRoute(getAuthContextFromStorage())
    if (target && target !== ROUTES.FORBIDDEN) {
      return (
        <Navigate to={target} replace state={{ accessDenied: true }} />
      )
    }
  }

  const backRoute = isCustomLoginActive ? ROUTES.LOGIN : ROUTES.LANDING

  return (
    <div className={`account-pages ${authPageClassName}`}>
      <Container
        style={{ display: "flex", alignItems: "center", height: "100%" }}
      >
        <Row className="justify-content-center login_form w-100">
          <Col md={12}>
            <Card className="overflow-hidden">
              <div className="login-platform-hero">
                <div className="p-4 text-center">
                  <h5 className="mb-1 text-uppercase">{brandTitle}</h5>
                  <p className="mb-0">{t("Access Forbidden")}</p>
                </div>
              </div>
              <CardBody className="pt-0">
                <AuthBrandingLogo />
                <div className="p-4 text-center">
                  <h1 className="display-1 fw-bold login-platform-forbidden__code mb-2">
                    403
                  </h1>
                  <div className="mb-3">
                    <i className="mdi mdi-shield-alert-outline display-4 login-platform-forbidden__icon" />
                  </div>
                  <h5 className="text-muted mb-3">
                    {t(
                      "Sorry, you don't have permission to access this resource."
                    )}
                  </h5>
                  <p className="text-muted mb-4">
                    {t(
                      "The page you are trying to access is restricted. Please contact your administrator if you believe this is an error."
                    )}
                  </p>
                  <Link to={backRoute} className="btn btn-primary">
                    <i className="mdi mdi-arrow-left me-1" />
                    {t("Go Back")}
                  </Link>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ForbiddenAccess
